import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import BackButtonSkeleton from './BackButtonSkeleton';
import AnimatedBg from './AnimatedBg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeadingSkeleton = () => {
  // don't render card heading in the card builder preview
  if (window.location.pathname.includes('card-builder-preview')) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "space-between",
    alignItems: "center",
    borderBlockEndColor: "border-core-subtle",
    borderBlockEndWidth: "100",
    borderBlockEndStyle: "solid",
    paddingInlineStart: "500",
    paddingInlineEnd: "200",
    blockSize: "40px",
    children: [/*#__PURE__*/_jsx(BackButtonSkeleton, {}), /*#__PURE__*/_jsx(View, {
      inlineSize: "80px",
      blockSize: "18px",
      borderRadius: "100",
      overflow: "hidden",
      children: /*#__PURE__*/_jsx(AnimatedBg, {})
    })]
  });
};
export default HeadingSkeleton;